import { singletonFactory } from '@warehouse/shared/util';
import { QuickBaseAuthService } from './quickbase-auth.service';
import { QuickBaseAuthServiceImpl } from './quickbase-auth.service.impl';

export const quickbaseAuthServiceSingleton = singletonFactory<QuickBaseAuthService>({
	factory: () => new QuickBaseAuthServiceImpl(),
});
